import {Component, Input, OnInit} from '@angular/core'
import {IQuestionComponent} from 'app/interfaces/IQuestionComponent'
import {AbstractControl} from '@angular/forms'
import {SurveyViewerService} from '../../../services/survey-viewer.service'
import {Props} from 'app/models/questions/Props'
import {OpenStatementErrorMatcher} from 'app/error-matchers/OpenStatementErrorMatcher'
import {OnDestroyMixin} from "@w11k/ngx-componentdestroyed";
import {PriceRangeErrorMatcher} from "../../../../../../error-matchers/PriceRangeErrorMatcher";

@Component({
  selector: 'app-price-range',
  templateUrl: './price-range.component.html',
  styleUrls: ['./price-range.component.scss'],
})
export class PriceRangeComponent extends OnDestroyMixin implements IQuestionComponent, OnInit {

  @Input() question: Props
  @Input() isSmallScreen: boolean
  @Input() activeLang: string

  questionFormControl: AbstractControl
  errorMatcher: PriceRangeErrorMatcher
  errorMessage: Record<string, string> = {}

  constructor(
    public surveyViewerService: SurveyViewerService) {
    super();

  }

  ngOnInit(): void {
    this.questionFormControl = this.surveyViewerService.activeSurvey$.value.form.get(this.question.key).get(this.question.rowKeys.pop()).get(this.question.commentsControlName)
    this.question.statementKeys.forEach(sKey => {
      this.surveyViewerService.changeFormUpdateStrategy(this.questionFormControl.get(sKey), 'blur');
    })
    this.questionFormControl.valueChanges.subscribe((data) => {
      this.updateErrorMessage()
    })
    this.errorMatcher = new PriceRangeErrorMatcher(this.question.isOptional)
  }

  updateErrorMessage() {
    this.errorMessage = Object.keys(this.questionFormControl.value)
      .reduce((acc, key) => {
        let message = 'Champ obligatoire';
        const value = this.questionFormControl.value[key]
        if (!value.trim().length) message = 'Champ obligatoire'
        else if (isNaN(+value)) message = 'La valeur doit être numérique'
        else if (+this.questionFormControl.value[key] <= 0) message = 'La valeur doit être supérieure à 0'
        else if (this.questionFormControl.parent.parent.errors) message = 'Valeur incohérente'
        return {...acc, [key]: message}
      }, {})
  }

}
